// import { getFetchMock } from './mocks/fetch';
import { FacilityDetails } from '@libs/models/facilities';
import { request } from '../request';

export async function fetchFacilityDetails(id: string): Promise<FacilityDetails> {
  const response = await request.get<FacilityDetailsResponseItem>(`/agencies/${id}`);
  return {
    ...response.data,
    address: {
      addressFirst: response.data.address.addressLine1,
      addressSecond: response.data.address.addressLine2,
      city: response.data.address.city,
      state: response.data.address.state,
      zipCode: response.data.address.zipCode,
    },
    facilityTypes: response.data.facilityTypes,
    status: response.data.status ?? 'Active',
  };
}

type FacilityDetailsResponseItem = {
  id: string;
  name: string;
  tenantId: string;
  createdOn: string;
  agencyType: string;
  facilityTypes: string[];
  contact: {
    email: string;
    firstName: string;
    phoneNumber: string;
    lastName: string;
  };
  address: {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
  };
  status: 'Pending' | 'Disconnected' | 'Active' | 'OnReview' | 'Invited';
};
